import { Login as DefaultLogin } from 'react-admin'

export const Login = () => <DefaultLogin backgroundImage="/bg.jpg" />
